const _ = require('lodash');
const formNameParser = require('../../form-validation-summary/form-name-parser');

/**
* Use this directive to capture <form /> client-side errors in Analytics.
* Usage Example:
***************************************************************************************************************************
*  <form name= "myForm" wow-analytics-form-errors ng-submit=submitForm() >
*      <input id = "myForm-Firstname" name = "FirstName" ngModel="FirstNameModel" />
*  </form
********************************************************************************************************************************
* If the id of the input field has periods in it, the last value after a period will be used (eg: <input id="formName" name="ctrl.formName"> will use formName as the form name. name="ctrl.form.name" will use name as the form name)
* Also note that validity for the input field needs to be "false" for it to display in the summary. Server errors will explicitly need to have validity set to false for the corresponding field.
*
* Based on the directive olyFormValidationSummary (not a dependency)
*/
module.exports = function (analyticsService) {
    return {
        restrict: 'A',
        require: 'form',
        link(scope, element, attrs, formCtrl) {
            const formName = formNameParser(formCtrl.$name);

            /**
             * The angular built-in validation tokens.
             */
            const formValidationTokens = ['email', 'max', 'maxlength', 'min', 'minlength', 'number', 'pattern', 'required', 'url', 'date', 'datetimelocal', 'time', 'week', 'month'];

            /**
             * Check whether there are any custom errors in the error object.
             * Custom form validation error types are often handled within component containing the form element.
             * This check can be used to avoid duplication of error pushes to Analytics.
            */
            const hasCustomFormError = function (error) {
                let isCustomError = false;
                _.forOwn(error, (value, key) => {
                    if (!_.includes(formValidationTokens, key)) {
                        isCustomError = true; // Set custom error is present.
                    }
                });

                return isCustomError;
            };

            const pushErrors = function () {
                if (hasCustomFormError(formCtrl.$error)) return;

                const errors = [];
                _.forEach(formCtrl, (value, field) => {
                    if (formCtrl[field] && formCtrl[field].$invalid) {
                        errors.push(`${formName}.${formCtrl[field].$name} is invalid.`);
                    }
                });

                if (errors.length > 0) {
                    analyticsService.pushErrors(errors);
                }
            };

            scope.$watch(() => formCtrl.$invalid && formCtrl.$dirty && formCtrl.$submitted, (newValue) => {
                if (newValue === true) {
                    pushErrors();
                }
            });

            scope.$watch(() => formCtrl.$submitted, (newValue) => {
                if (newValue === true) {
                    pushErrors();
                }
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/analytics/analytics/analytics-form-errors.directive.js